<div class="delete-collection-popup">
    <div class="delete-collection-header">
        <label class="collection-header-title">Delete Collection</label>
        <button class="header-close" (click)="closePopup()"></button>
    </div>
    <div class="delete-collection-content">
        Do you want to delete <span class="weight-bold">{{collection?.featureName}}</span> collection? Collection will also be removed from production.
    </div>
    <div class="delete-collection-footer">
        <button mat-button mat-dialog-close class="collection-popup-close" (click)="closePopup()">Cancel</button>
        <button class="collection-delete" mat-button (click)="deleteCollection()">Delete Collection</button>
    </div>
    
</div>
<saving-in-progress [showSavingInProgress]="savingInProgress" [inProgressMessage]="'Deleting in progress...'"></saving-in-progress>